// Runs inside the generated page. Report layout evidence without changing it.
export const imageDiagnostics = String.raw`
const assetSources = new Map(Object.entries(assetURLs || {}).map(([id,url])=>[url,'unity-asset:'+id]));
const imageLabel = element => (element.tagName.toLowerCase() + (element.id ? '#'+element.id : '') +
    Array.from(element.classList || []).slice(0,3).map(name=>'.'+name).join('')).slice(0,160);
const inspectImageLayout = image => {
    const rect=image.getBoundingClientRect(), style=getComputedStyle(image);
    let left=rect.left,top=rect.top,right=rect.right,bottom=rect.bottom;
    let hidden=!rect.width || !rect.height || style.visibility==='hidden' || style.visibility==='collapse' || style.display==='none' || style.opacity==='0';
    const clippedBy=[];
    for(let parent=image.parentElement;parent;parent=parent.parentElement){
        const css=getComputedStyle(parent);
        if(css.display==='none' || css.opacity==='0') hidden=true;
        const clipX=['hidden','clip'].includes(css.overflowX || css.overflow);
        const clipY=['hidden','clip'].includes(css.overflowY || css.overflow);
        // Scrollable content is reachable by the user; do not call it clipped.
        if(!clipX && !clipY) continue;
        const bounds=parent.getBoundingClientRect();
        if((clipX && (left<bounds.left || right>bounds.right)) || (clipY && (top<bounds.top || bottom>bounds.bottom)))
            clippedBy.push(imageLabel(parent));
        if(clipX){left=Math.max(left,bounds.left);right=Math.min(right,bounds.right);}
        if(clipY){top=Math.max(top,bounds.top);bottom=Math.min(bottom,bounds.bottom);}
    }
    const visibleWidth=Math.max(0,right-left),visibleHeight=Math.max(0,bottom-top);
    const visibleFraction=rect.width && rect.height ? visibleWidth*visibleHeight/(rect.width*rect.height) : 0;
    return {id:image.closest('[data-unity-visual]')?.getAttribute('data-unity-visual'),
        element:(image.parentElement ? imageLabel(image.parentElement)+' > ' : '')+imageLabel(image),
        asset:assetSources.get(image.currentSrc || image.getAttribute('src')),alt:image.alt,
        loaded:image.complete && image.naturalWidth>0,hidden,
        naturalWidth:image.naturalWidth,naturalHeight:image.naturalHeight,
        x:Math.round(rect.x+scrollX),y:Math.round(rect.y+scrollY),width:Math.round(rect.width),height:Math.round(rect.height),
        visibleWidth:Math.round(visibleWidth),visibleHeight:Math.round(visibleHeight),visibleFraction:Math.round(visibleFraction*100000)/100000,
        clippedBy,objectFit:style.objectFit};
};
`;
